import React from "react";
import { Link } from "react-router-dom";
import footbg from "../Assets/footbg.png";
const Footer = () => {
  const divStyle = {
    backgroundImage: `url(${footbg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "100%", // Set the height of the div to 100% of the viewport height
  };
  return (
    <div className='bg-green-800'>
      {/* <img src={footbg} alt='footer' className='h-full w-full object-cover' /> */}

      <div className=''>
        <div className=' bg-yellow w-screen'>
          <div className='lg:container px-4 mx-auto py-5 h-full'>
            <div className='flex flex-col justify-center items-center slg:flex-row slg:items-center h-full lg:gap-14 slg:justify-between w-full'>
              {/* Left Side */}
              <div className='space-y-4 flex flex-col justify-center h-full slg:w-[30%]'>
                <h1 className='font-bold text-2xl text-white'>NEWSLETTER</h1>
                <p className='font-semibold texl-sm text-neutral-200 '>
                  Subscribe to our newsletter and get the latest updates.
                </p>
                <form action='#' method='POST' autoComplete='off'>
                  <div className='flex'>
                    <input
                      type='text'
                      className='h-12 w-[15rem] px-2 outline-none'
                      placeholder='Email'
                    />
                    <button className='bg-black text-white font-semibold px-6'>
                      Suscribe
                    </button>
                  </div>
                </form>
              </div>

              {/* Right Side  */}
              <div className='grid grid-cols-3 md:grid-cols-3 lg:self-start mt-8 gap-11 gap- lg:w-[70%]'>
                <div className=''>
                  <h1 className='font-bold text-lg mb-2 text-white'>
                    Navigation
                  </h1>
                  <div className=''>
                    <ul className='space-y-4'>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          Donate
                        </Link>
                      </li>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          Gallery
                        </Link>
                      </li>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          Projects
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className=''>
                  <h1 className='font-bold text-lg mb-2 text-white'>
                    About Us
                  </h1>
                  <div className=''>
                    <ul className='space-y-4'>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          Contact Us
                        </Link>
                      </li>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          Gallery
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className=''>
                  <h1 className='font-bold text-lg mb-2 text-white'>Help</h1>
                  <div className=''>
                    <ul className='space-y-4'>
                      <li>
                        <Link
                          to={`/faq`}
                          className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'
                        >
                          FAQ
                        </Link>
                      </li>
                      <li>
                        <Link className='hover:text-yellow-500 text-neutral-300 font-semibold text-sm'>
                          Help
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mt-8'>
              <div className='flex w-full items-center justify-between lg:px-24 text-white'>
                <h1>
                  <a href='Youtube.com'>Facebook</a>
                </h1>
                <h1>
                  <a href='Youtube.com'>Youtube</a>
                </h1>
                <h1>
                  <a href='ig.com'>Instagram</a>
                </h1>
              </div>

              <div className='border-b-2 w-full my-4 border-b-neutral-300'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
